/**
 * Gmail icon component using official Gmail brand colors
 */
import React from 'react';
import { cn } from '../../../lib/utils';

interface GmailIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function GmailIcon({ className, ...props }: GmailIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('h-5 w-5', className)}
      {...props}
    >
      <path d="M1.636 21h3.273V11.727L0 7.91v11.455C0 20.27.732 21 1.636 21z" fill="#4285F4" />
      <path d="M19.091 21h3.273c.904 0 1.636-.732 1.636-1.636V7.909l-4.909 3.818V21z" fill="#34A853" />
      <path d="M19.091 4.636v7.091L24 7.909V5.455c0-2.275-2.597-3.572-4.418-2.21l-.491.368z" fill="#FBBC04" />
      <path d="M4.909 11.727V4.636L12 9.955l7.091-5.319v7.091L12 17.046z" fill="#EA4335" />
      <path d="M0 5.455v2.454l4.909 3.818V4.636l-.491-.368C2.597 1.883 0 3.18 0 5.455z" fill="#C5221F" />
    </svg>
  );
}
